import React, { FC } from 'react';

import { Box, Center, HStack } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { PrimaryButton } from 'components/DataEntry';
import { PrimaryButtonProps } from 'components/DataEntry/Button/types';

export const GrayIconButton: FC<PrimaryButtonProps> = props => {
  const { leftIcon, children, iconSize = 5, iconSpacing = 2, ...rest } = props;

  return (
    <PrimaryButton
      //px={0}
      //py={0}
      border="1px solid"
      bg="transparent"
      //fontSize="16px"
      color={customTheme.colors.gray['300']}
      borderColor={customTheme.colors.gray['100']}
      _hover={{ color: customTheme.colors.primary }}
      _active={{ color: customTheme.colors.primary }}
      _focus={{ color: customTheme.colors.primary }}
      {...rest}
    >
      <HStack spacing={iconSpacing}>
        <Center boxSize={iconSize}>
          <Center>{leftIcon}</Center>
        </Center>
        <Box>{children}</Box>
      </HStack>
    </PrimaryButton>
  );
};
